import {Component, OnInit} from '@angular/core';
import {TEST_RESULT_PRIVILEGES} from '../../../../constants/privileges';
import {TestResult} from '../../../data/models/result/test-result';
import {ActivatedRoute, Router} from '@angular/router';
import {TestResultService} from '../../../services/api/result/test-result.service';
import {Test} from '../../../data/models/test/test';
import {TestService} from '../../../services/api/test.service';
import {QuestionResult} from '../../../data/models/result/question-result';
import {QuestionResultService} from '../../../services/api/result/question-result.service';
import {TestResultCommitDialogComponent} from '../../../components/dialogs/test-result-commit-dialog/test-result-commit-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {TestResultCancelDialogComponent} from '../../../components/dialogs/test-result-cancel-dialog/test-result-cancel-dialog.component';
import {MeService} from '../../../services/api/me.service';
import {TestResultDeleteDialogComponent} from '../../../components/dialogs/test-result-delete-dialog/test-result-delete-dialog.component';

@Component({
  selector: 'app-test-result-page',
  templateUrl: './test-result-page.component.html',
  styleUrls: ['./test-result-page.component.css']
})
export class TestResultPageComponent implements OnInit {

  readonly PRIVILEGES = TEST_RESULT_PRIVILEGES;

  test: Test | null = null;
  testResult: TestResult | null = null;
  questionResults: QuestionResult[] = [];

  canEdit = false;
  canCommit = false;
  canCancel = false;
  canDelete = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private meService: MeService,
    private testService: TestService,
    private testResultService: TestResultService,
    private questionResultService: QuestionResultService,
  ) {
  }

  ngOnInit(): void {
    const testId = +(this.route.snapshot.paramMap.get('testId') || 0);
    const testResultId = +(this.route.snapshot.paramMap.get('resultId') || 0);
    if (testId && testResultId) {
      this.testService.getTest(testId)
        .then(test => {
          this.test = test;
        });
      this.testResultService.getTestResult(testResultId)
        .then(testResult => {
          this.testResult = testResult;
          this.updatePermissions();
        });
      this.questionResultService.getQuestionResults(testResultId)
        .then(questionResults => {
          this.questionResults = questionResults;
        });
    }
  }

  updatePermissions(): void {
    if (this.testResult) {
      this.canEdit = this.testResult.checkDate === null && this.testResult.deleteDate === null &&
        this.meService.hasPrivilege(this.PRIVILEGES.UPDATE);
      this.canCommit = this.testResult.checkDate === null && this.testResult.deleteDate === null &&
        this.meService.hasPrivilege(this.PRIVILEGES.COMMIT);
      this.canCancel = this.testResult.checkDate !== null && this.testResult.deleteDate === null &&
        this.meService.hasPrivilege(this.PRIVILEGES.CANCEL);
      this.canDelete = this.testResult.checkDate === null && this.testResult.deleteDate === null &&
        this.meService.hasPrivilege(this.PRIVILEGES.DELETE);
    }
  }

  openTestResultCommitDialog(): void {
    const dialogRef = this.dialog.open(TestResultCommitDialogComponent, {
      minWidth: '20vw',
      data: {
        testResult: this.testResult
      }
    });

    dialogRef.afterClosed().subscribe(testResult => {
      if (testResult) {
        this.testResult = testResult;
        this.updatePermissions();
      }
    });
  }

  openTestResultCancelDialog(): void {
    const dialogRef = this.dialog.open(TestResultCancelDialogComponent, {
      minWidth: '10vw',
      data: {
        testResult: this.testResult
      }
    });

    dialogRef.afterClosed().subscribe(testResult => {
      if (testResult) {
        this.testResult = testResult;
        this.updatePermissions();
      }
    });
  }

  openTestResultDeleteDialog(): void {
    const dialogRef = this.dialog.open(TestResultDeleteDialogComponent, {
      data: {
        testResult: this.testResult,
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.test) {
        this.router.navigate(['tests', this.test.id, 'results']);
      }
    });
  }

  exportResult(): void {
      const testId = this.test?.id;
      const resultId = this.testResult?.id;
      const fileName = 'Результаты № ' + resultId + ' по тесту № ' + testId;
      const downloadUrl = new URL(`/api/test-results/${resultId}/export/${fileName}.xlsx`, window.location.href);
      window.open(downloadUrl.toString(), '_blank');
  }

}
